import { useEffect, useState } from 'react';
import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
} from '@heroui/react';
import type { FamiliaProducto } from '@/types/familia-producto.model';

interface FamiliaProductoDetailModalProps {
  isOpen: boolean;
  onClose: () => void;
  familiaProducto?: FamiliaProducto;
}

const FamiliaProductoDetailModal = ({ isOpen, onClose, familiaProducto }: FamiliaProductoDetailModalProps) => {
  const [detailData, setDetailData] = useState<FamiliaProducto | undefined>(undefined);

  // Populate form when familiaProducto changes
  useEffect(() => {
    if (familiaProducto) {
      setDetailData(familiaProducto);
    } else {
      setDetailData(undefined);
    }
  }, [familiaProducto]);

  return (
    <Modal 
      isOpen={isOpen} 
      onClose={onClose}
      placement="top-center"
      backdrop="blur"
      size="2xl"
    >
      <ModalContent>
        {(onClose) => (
          <>
            <ModalHeader className="flex flex-col gap-1">Detalle de la Familia de Producto</ModalHeader>
            <ModalBody className="space-y-4">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">ID</label>
                  <p className="text-gray-900 bg-gray-100 p-2 rounded border">
                    {detailData?.id || 'N/A'}
                  </p>
                </div>
                
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Nombre</label>
                  <p className="text-gray-900 bg-gray-100 p-2 rounded border">
                    {detailData?.nombre || 'N/A'}
                  </p>
                </div>
                
                <div className="md:col-span-2">
                  <label className="block text-sm font-medium text-gray-700 mb-1">Descripción</label>
                  <p className="text-gray-900 bg-gray-100 p-2 rounded border">
                    {detailData?.descripcion || 'N/A'}
                  </p>
                </div>
                
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Fecha de Creación</label>
                  <p className="text-gray-900 bg-gray-100 p-2 rounded border">
                    {detailData?.createdAt ? new Date(detailData.createdAt).toLocaleString() : 'N/A'}
                  </p>
                </div>
                
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Fecha de Actualización</label>
                  <p className="text-gray-900 bg-gray-100 p-2 rounded border">
                    {detailData?.updatedAt ? new Date(detailData.updatedAt).toLocaleString() : 'N/A'}
                  </p>
                </div>
              </div>
            </ModalBody>
            <ModalFooter>
              <Button 
                color="primary" 
                variant="light" 
                onPress={onClose}
              >
                Cerrar
              </Button>
            </ModalFooter>
          </>
        )}
      </ModalContent>
    </Modal>
  );
};

export default FamiliaProductoDetailModal;